<template>
    <div>        
        <div v-if="false && this.$parent.employeePlannedActual[employee.id].vertrag == 0" class="noContract">
                {{ $t('roster.comp.considerPastPlans') }}
        </div>
        <div v-if="true || this.$parent.employeePlannedActual[employee.id].vertrag > 0">
            <div style="margin-top:-12px; padding-top: 0px; height: 30px; overflow:hidden;" v-bind:style="{ width: (indentationLevel == 0 ? widthIndentation0+'px' : widthIndentation1+'px')}">
                
                <!-- Gray Background Bar -->
                <div class="background-bar"
                    v-bind:class="{lowered: (roster.employeePlannedActual[employee.id].sollWorkTime != roster.employeePlannedActual[employee.id].unmodifiedPlannedWorkTime) || (roster.employeePlannedActual[employee.id].deltaWorkTime != roster.employeePlannedActual[employee.id].unmodifiedDeltaWorkTime)}"
                    v-bind:style="{ 
                        width: (((indentationLevel == 0) ?widthIndentation0 : widthIndentation1) - leftMargin - rightMargin) + 'px'}">
                    <div class="foreground-bar" v-bind:style="{width: variables.summAllWidth+'px'}"></div>
                    <!-- Red overtime #e5154f -->
                    <div v-if="variables.red_overtime_width > 0" 
                        class="foreground-bar overtime"
                        v-bind:style="{'margin-left':(indentationLevel == 0 ? (variables.widthIndentation0Calc-1)+'px' : (variables.widthIndentation1Calc-1)+'px'),  width: (variables.red_overtime_width+1)+'px'}">
                    </div>
                </div>
                <div style="margin-top:-30px; height:0px;"></div>
                <!-- Gray Background Bar END -->

                <!-- TEXT -->
                <div class="work-value"
                v-bind:style="{ width: (indentationLevel == 0 ? variables.widthIndentation0+'px' : variables.widthIndentation1+'px')}">{{ amountDisplayed }}</div>
                <div style="margin-top:-18px; height:0px;"></div>
               
                <div style="margin-top:-18px; height:0px;"></div>
                <!-- TEXT END -->
                <div class="accumulated-holiday-icon" v-if="hasFtTime" v-tooltip="$t('workBalance.payroll.holidayBalance')" v-bind:class="{'time-too-low': timeTooLow, 'time-too-high': timeTooHigh}" @mouseenter="workTimeToggle = true" @mouseleave="workTimeToggle = false"></div>
                <!-- Alle Plan Zeiten -->
                <div style="margin-top:-29px; height:0px;"></div>


                <!-- WIP MARKER FOR FT
                <div style="position: absolute; left: 223px; margin-top:4px; height:14px; margin-left:0px; line-height: 14px; text-align: right; color:var(--contrast-4); font-size: 10px; padding-right: 5px;" v-if="$parent.employeePlannedActual[employee.id].deltaFtWorkTime > 0">
                    FT!
                </div> -->
            </div>

            <div style="height: 10px; margin-top:-11px; border-right:1px solid #000;" v-bind:style="{display: (overflow < 1 ? 'block' : 'none'), width: (indentationLevel == 0 ? variables.widthIndentation0Calc+'px' : variables.widthIndentation1Calc+'px')}"></div>
        </div>
            
    </div>
</template>
<script>
    export default {
        name: 'plannedActualbars',
        components: {
        },
        data(){
            return{
                widthIndentation0 : 173,
                widthIndentation1 : 153,
                leftMargin: 5,
                rightMargin: 2,
                overflow: 1,
                workTimeToggle: false,
                roster: null,
            }
        },
        props:{
            indentationLevel: Number,
            employee: null,
        },

        watch: {
        },

        created () {
         this.roster = this.$parent;
        },
        destroyed(){
        },
        
        computed: {
            amountDisplayed(){
                if(!this.roster) return '-';
                if(!this.workTimeToggle){
                    return (this.roster.employeePlannedActual[this.employee.id].total/1000/3600).toFixed(2).toString().replace('.', ',');
                } else {
                    return (this.roster.employeePlannedActual[this.employee.id].sumFtWorkTime/1000/3600 + this.roster.employeePlannedActual[this.employee.id].deltaFtWorkTime/1000/3600).toFixed(2).toString().replace('.', ',');
                }
               
            },
            timeTooHigh(){
                if(!this.roster) return true;
                
                return this.roster.employeePlannedActual[this.employee.id].totalWithoutHolidayWorkTime < 0 && (this.roster.employeePlannedActual[this.employee.id].sumFtWorkTime + this.roster.employeePlannedActual[this.employee.id].deltaFtWorkTime > 0)
            },
            timeTooLow(){
                if(!this.roster) return true;
                
                return (this.roster.employeePlannedActual[this.employee.id].sumFtWorkTime + this.roster.employeePlannedActual[this.employee.id].deltaFtWorkTime < 0)
            },
            hasFtTime(){
                if(!this.roster) return false;
                
                return ((this.roster.employeePlannedActual[this.employee.id].sumFtWorkTime + this.roster.employeePlannedActual[this.employee.id].deltaFtWorkTime) != 0)
            },
            variables() {
                let vars = {
                        'widthIndentation0Calc'         : this.widthIndentation0,
                        'widthIndentation1Calc'         : this.widthIndentation1,
                        'oneMinuteInPixel'              : 0,
                        'summAllWidth'                  : 0,
                        'red_overtime_width'            : 0,
                    };

                    let obj = this.$parent.employeePlannedActual[this.employee.id];
                    vars.widthIndentation0Calc = this.widthIndentation0 * this.$parent.plannedActualOverflow(this.employee.id);
                    vars.widthIndentation1Calc = this.widthIndentation1 * this.$parent.plannedActualOverflow(this.employee.id);

                    if(this.indentationLevel == 0){
                        vars.oneMinuteInPixel = this.widthIndentation0 / (obj.sollWorkTime)* this.$parent.plannedActualOverflow(this.employee.id);// Calculate one Minute in Pixels
                    }else{
                        vars.oneMinuteInPixel = this.widthIndentation1 / (obj.sollWorkTime) * this.$parent.plannedActualOverflow(this.employee.id);// Calculate one Minute in Pixels
                    }

                    //console.log(this.$parent.employeeMap[this.employee.id].firstName + " - " + this.$parent.employeeMap[this.employee.id].lastName);
                    //console.log(obj.vertrag+obj.balance);

                    vars.summAllWidth = Math.max(0,Math.min(obj.sollWorkTime,(obj.sollWorkTime+obj.total))) * vars.oneMinuteInPixel;

                    if(obj.total > 0){
                        vars.red_overtime_width = Math.max(2,obj.total * vars.oneMinuteInPixel); // take at least 2 pixels so it don't look like garbage
                        vars.widthIndentation0 += vars.red_overtime_width;
                        vars.widthIndentation1Calc += vars.red_overtime_width;
                    }

                return vars;
            }
        },
        methods: {
        },
        mounted() {
            //$('html').append(this.$el);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .noContract{
        font-size: 13px;
        color: #e5154f;
        text-align: left;
        height: 15px;
        white-space: nowrap;
        font-weight: 800;
    }
    
    .accumulated-holiday-icon{
        position: absolute;
        height: 8px;
        width: 8px;
        bottom: 30px;
        right: 40px;
        border-radius: 100px;
        background: #b2b2b2;
        z-index: 10;
        cursor: help;
    }
    
    .time-too-high{
        background: #2f61ab;
    }

    .time-too-low{
        background: #e5154f;
    }
    
    .work-value{
        margin-top:6px;
        height:14px;
        margin-left:0px;
        margin-right:7px;
        line-height: 1px;
        text-align: right;
        color: #b2b2b2;
        font-size: 11px;
        padding-right: 5px;
    }

    .background-bar.lowered{
        outline:solid var(--col-planned-actual-calculation-border) 2px;
    }

    .background-bar, .foreground-bar{
        margin-top: 17px;
        height: 11px;
        background-color: var(--contrast-3);
        border-radius: 200px;
        width: 170px;
        margin-left: 5px;
        margin-right: 2px;
        overflow: hidden;
        position: relative;
    }
    .foreground-bar {
        background-color: var(--contrast-5);
        margin: 0;
        border-radius: 0 200px 200px 0;
    }
    
    .foreground-bar.overtime{
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--col-danger);
    }
</style>
